import * as React from 'react';
import { CloseClear } from '@websky/core';
const PassengersCloseBtn = ({ close }) => (React.createElement("span", { onClick: close }, CloseClear));
export default PassengersCloseBtn;
